var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-cities"},[_c('img',{staticClass:"icon",attrs:{"src":"/img/brand/empty/empty-list.svg","alt":"cup","loading":"lazy"}})])}]

export { render, staticRenderFns }